"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _toolkit = require('@reduxjs/toolkit');
var _selectMyChatSubscriber = require('./selectMyChatSubscriber');

 const selectMyOrgKeyInConvo = _toolkit.createSelector.call(void 0, 
  _selectMyChatSubscriber.selectMyChatSubscriber,
  subscriber => subscriber
    ? subscriber.OrgKey || 'DefaultOrgKey' in subscriber && subscriber.DefaultOrgKey || null
    : null,
); exports.selectMyOrgKeyInConvo = selectMyOrgKeyInConvo
